module.exports = __webpack_public_path__ + "static/media/aea91d48-6b1e-4be5-b336-f8ee79f8a237-Hux6WMDzK7bILpqGPQJiZqnSxhl7oj.cdab0426.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aea91d48-6b1e-4be5-b336-f8ee79f8a237-Hux6WMDzK7bILpqGPQJiZqnSxhl7oj.webp
// module id = 628
// module chunks = 0